module.exports = __webpack_public_path__ + "static/img/jia.1c68fa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/manman/images/jia.jpg
// module id = +i8b
// module chunks = 21